module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'fields',
        'select',
    ],

    methods: {
        prepare: function(){
            var self = this;
            this.closest('templates_crew_timeRecordings_table_table', function(resourceLoadingComponent){
                if((((((resourceLoadingComponent.resourceData || {}).data || {}).children || {}).jobs || {}).data || []).length > 0){
                    var options = []
                    for(var j in resourceLoadingComponent.resourceData.data.children.jobs.data){
                        var job = resourceLoadingComponent.resourceData.data.children.jobs.data[j] || {}
                        var jobAttributes = job.attributes || {}
                        if(jobAttributes.key){
                            var name = jobAttributes.shortTitle
                            if(jobAttributes.title != jobAttributes.shortTitle && jobAttributes.title){
                                name += ` - ${jobAttributes.title}`
                            }
                            options.push({
                                name,
                                value:              jobAttributes.key,
                                defaultSelected:    jobAttributes.defaultSelected
                            });
                        }
                    }

                    self.model[`${self.model.atom.dataType}-data`] = options
                }
            });
        }
    }
}